import { Locale } from '@ps-smart-cp/ppfw-client';

const imporJudgeIfrsBasisConfig = {
  notExecute: new Map([[Locale.ja, '実施しない']]),
  execute: new Map([[Locale.ja, '実施する']]),
};

export { imporJudgeIfrsBasisConfig };
